export default __webpack_public_path__ + "static/media/Pretendard-Bold.subset.fd82943b.woff";